import { PublicEvent } from './types';

export const sendPublicEvent = (event: PublicEvent) => {
  window.dispatchEvent(
    new CustomEvent(event.type, {
      detail: event.payload,
    })
  );
};
